import { BaseController } from "../base/controller";
export class ListController extends BaseController {
}
